import { useState } from "react";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";
import "./index.scss";
import plus from "../../../../assets/images/+.svg";

const WhoCanApplySection = () => {
  const [whoApply] = useState([
    "3rd, 4th-grade students, new graduates and master students from various universities all over Turkey with a related Bachelor’s degree",
    "Intermediate and above English level",
    "People who decide on the sector they want to work in and plan their career journey",
    "Candidates who took part in activities that will make a difference in their CV",
    "Young talents who aim to demonstrate their competencies by expressing themselves easily",
  ]);

  return (
    <section id="who-can-apply" className="who-can-apply-section">
      <Container>
        <Row>
          <Col sm="12" md="12" lg="12" data-aos="fade-right">
            <h5 className="title">
              WHO CAN <br /> APPLY?
            </h5>
            <div className="who-can-apply-list">
              <ListGroup>
                {whoApply.map((w, index) => {
                  return (
                    <ListGroupItem key={index}>
                      <img
                        src={plus}
                        alt="plus"
                        width="20px"
                        height="20px"
                        style={{ marginRight: "10px" }}
                      />
                      {w}
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default WhoCanApplySection;
